import type { FundPolicy } from '../../core/fundPolicy/schema';
import {
  isWindowOpen,
  visibleItems,
} from '../../features/declarations/application/declarationForm';
import { useMyDeclaration } from '../../features/declarations/application/useMyDeclaration';
import { DeclarationPage, type DeclarationField } from '../../pages/DeclarationPage';

import { useServices } from '../providers/servicesContext';

/**
 * Connects the declaration screen to its port.
 *
 * The form is built from the stored policy, so a committee edit to the
 * declaration items changes this screen with no deploy.
 */
export function DeclarationScreen({
  policy,
  nowIso,
}: {
  readonly policy: FundPolicy;
  readonly nowIso: string;
}) {
  const { declarations } = useServices();
  const controller = useMyDeclaration(declarations, policy, true);

  const fields: readonly DeclarationField[] = visibleItems(policy).map((item) => ({
    id: item.id,
    labelAr: item.labelAr,
    ...(item.helpAr === undefined ? {} : { helpAr: item.helpAr }),
    type: item.type,
    required: item.required,
    ...(item.options === undefined ? {} : { options: item.options }),
  }));

  const windowClosed = !isWindowOpen(policy, nowIso);

  return (
    <DeclarationPage
      fields={fields}
      answers={controller.answers}
      missingItemIds={controller.missingItemIds}
      missingLabelsAr={controller.missingLabelsAr}
      readOnly={controller.readOnly || windowClosed}
      submitted={controller.submitted}
      windowClosed={windowClosed}
      reviewNoteAr={controller.reviewNoteAr}
      saving={controller.saving}
      savedAr={controller.savedAr}
      errorAr={controller.errorAr}
      onChange={controller.change}
      onSaveDraft={controller.saveDraft}
      onSubmit={controller.submit}
    />
  );
}
